export function getUtcDate(date: Date): Date
export function getUtcDate(date: null | undefined): undefined
export function getUtcDate(date: Date | null | undefined): Date | undefined {
  if (!date) {
    return undefined
  }

  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  )
}
